import { styled } from '@mui/material/styles';
import MuiTextField, {
  TextFieldProps,
} from '@mui/material/TextField';

const TextField = ({
  mode = 'light',
  className,
  'aria-label': ariaLabel,
  ...props
}: {
  className?: string;
  mode?: 'light' | 'dark';
  'aria-label'?: string;
} & TextFieldProps) => (
  <Root
    {...props}
    className={
      // @ts-expect-error startAdornment exists in slot input
      (props.slotProps?.input?.startAdornment
        ? 'start-adornment'
        : '') +
      ' ' +
      className
    }
    slotProps={{
      input: {
        // @ts-expect-error startAdornment exists in slot input
        startAdornment: props.slotProps?.input?.startAdornment,
      },
      inputLabel: {
        shrink: !!props.value,
      },
    }}
    aria-label={ariaLabel}
    mode={mode}
  />
);

const Root = styled(MuiTextField)<{ mode: 'light' | 'dark' }>(
  ({ theme, size, mode }) => ({
    marginTop: theme.spacing(1),

    '.MuiInputAdornment-root': {
      margin: 0,
    },

    label: {
      fontSize: `${size === 'small' ? 14 : 14}px !important`,
      color:
        mode === 'light'
          ? theme.palette.textGray
          : theme.palette.white,

      '&.Mui-focused': {
        color:
          mode === 'light'
            ? theme.palette.primary.main
            : theme.palette.red400,
      },
    },

    'label:not(.MuiInputLabel-shrink)': {
      transform:
        size === 'small'
          ? 'translate(8px, 8px) scale(1)'
          : 'translate(14px, 13px) scale(1)',
      color:
        mode === 'light'
          ? theme.palette.textGray
          : theme.palette.white,
      fontSize: size === 'small' ? 14 : 16,
      lineHeight: size === 'small' ? '20px' : '24px',
    },

    '&.start-adornment label:not(.MuiInputLabel-shrink)': {
      transform:
        size === 'small'
          ? 'translate(48px, 8px) scale(1)'
          : 'translate(48px, 9px) scale(1)',
    },
    '.MuiInputBase-root': {
      borderRadius: 8,

      '&:hover fieldset, &.Mui-focused fieldset': {
        borderColor:
          mode === 'light'
            ? theme.palette.black
            : theme.palette.red400,
      },
    },
    input: {
      padding: size === 'small' ? 8 : 12,
      height: size === 'small' ? 36 : 40,
      fontSize: size === 'small' ? 14 : 14,
      lineHeight: size === 'small' ? '20px' : '24px',
      boxSizing: 'border-box',
      color:
        mode === 'light' ? theme.palette.black : theme.palette.white,
    },
    '.MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.grey200,
    },
  }),
);

export default TextField;
